var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('nav',{staticClass:"about-nav"},[_c('router-link',{attrs:{"to":"/about/quick-answer","tabindex":"0","exact":""}},[_vm._v("en bref")]),_c('router-link',{attrs:{"to":"/about/in-depth-answer","tabindex":"0","exact":""}},[_vm._v("en détails")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }